import { ActionType } from '../infrastructure/actionTypes';
import { ITechSheet } from '../infrastructure/interfaces';

export default (list: ITechSheet[] = [], action: any) => {
  switch (action.type) {
    case ActionType.GET_TECH_SHEETS_DONE:
      const { agronomyReferenceSheets } = action;
      return agronomyReferenceSheets
    case ActionType.TOGGLE_TECH_SHEET_PUBLISH_DONE:
        const { toggledTechSheet } = action;
        const toggledList = list.map((t) => {
          return (t.id == toggledTechSheet.id) ? toggledTechSheet : t
        });
        return toggledList
    case ActionType.CREATE_TECH_SHEET_DONE:
      const { newTechSheet } = action;
      return list.concat(newTechSheet);
    case ActionType.DELETE_ALL_TECH_SHEETS_DONE:
      list = []
    return list;
    default:
      return list;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/techSheetList.ts